module.exports = __webpack_public_path__ + "static/media/Nicola Casey 2.69dfe008.jpg";